<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Borderou</h2>
        </div>
    </div>
</div>
<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Listă borderou</h3>
                        <div class="row">
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="reset()">
                                    <i class="fa-solid fa-arrows-rotate"></i>
                                </button>
                                <button *ngIf="selectedTabelBorderou.slug !== 'toate' && isAllowedBorderou()"
                                    type="button" class="btn btn-sm btn-primary pull-right ms-1"
                                    (click)="openAddDialog()">
                                    <i class="fa-solid fa-plus"></i>
                                    Incarcă
                                </button>
                                <button *ngIf="selectedTabelBorderou.slug !== 'toate' && isAllowedBorderou()"
                                    type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="print()">
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-filters m-2">
                        <div class="col d-flex justify-content-center">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onTableChange($event)" [value]="defaultParameter">
                                <mat-button-toggle *ngFor="let option of borderou$ | async" [value]="option">
                                    {{ option.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <div *ngIf="selectedTabelBorderou.slug !== 'toate' && isAllowedBorderou()"
                        class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div class="mx-2">
                            <mat-form-field class="w-100">
                                <mat-label>Dată</mat-label>
                                <input matInput [matDatepicker]="picker" [(ngModel)]="dateBorderou" readonly
                                    (focus)="picker.open()" (dateChange)="onDateChange($event)" />
                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div *ngIf="current_info" class="m-2 current-info">
                            <span>{{ current_info.document_type + '/' + current_info.data}}</span>
                            <span> - </span>
                            <span class="current-info-link" (click)="downloadBorderouInfo(current_info.id)">{{
                                current_info.document_file_name
                                }}</span>
                        </div>
                    </div>

                    <div
                        *ngIf="!allowedBorderouSlugs.includes(selectedTabelBorderou.slug)  || selectedTabelBorderou.slug === 'toate'">
                        <app-toate-tabel-borderou></app-toate-tabel-borderou>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'modificare_aviz_orar'">
                        <app-modificare-aviz-orar [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-modificare-aviz-orar>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'acord_temporar'">
                        <app-acord-temporar-toate [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-acord-temporar-toate>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'alimentatie_publica'">
                        <app-alimentatie-publica [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-alimentatie-publica>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'recreative'">
                        <app-recreative [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-recreative>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'prelungire_acord_functionare'">
                        <app-prelungire-acorduri-functionare [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-prelungire-acorduri-functionare>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'acord_temporar_terase'">
                        <app-acord-temporar-terase [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-acord-temporar-terase>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'autorizatii_piata_targ'">
                        <app-autorizatie-targ-piata [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-autorizatie-targ-piata>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'acord_functionare'">
                        <app-acord-functionare [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-acord-functionare>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'acord_comercializare'">
                        <app-acord-comercializare [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-acord-comercializare>
                    </div>
                    <div *ngIf="selectedTabelBorderou.slug === 'terase_sezoniere'">
                        <app-acord-terase-sezoniere [dataTableParams]="dataTableParams"
                            [type_slug]="borderou_slug"></app-acord-terase-sezoniere>
                    </div>
                </div>

                <div class="section-spinner position-absolute" *ngIf="isLoading">
                    <div class="spinner position-absolute top-50 start-50 translate-middle">
                        <mat-spinner></mat-spinner>
                        <h3 class="mt-2">
                            {{ helper.dialogConfig.generalMessages.pleaseWait }}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>